import { Pipe, PipeTransform, inject } from '@angular/core';
import { AdminProductStatus } from '../enums/admin-product-status';
import { Observable } from 'rxjs';
import { AdminProductStatusProviderService } from '../providers/admin-product-status-provider.service';

@Pipe({
  name: 'adminProductStatus',
})
export class AdminProductStatusPipe implements PipeTransform {
  private readonly provider = inject(AdminProductStatusProviderService);

  public transform(status: AdminProductStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
